import { render, staticRenderFns } from "./UploadModalContent.vue?vue&type=template&id=5bafd3e4&"
import script from "./UploadModalContent.vue?vue&type=script&lang=js&"
export * from "./UploadModalContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports